import { useTranslation } from "react-i18next";

export default function Safety() {
  const { t } = useTranslation();

  return (
    <section id="safety" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden order-2 md:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20concept%20illustration%20of%20online%20shopping%20security%20featuring%20a%20padlock%20and%20credit%20card%20with%20a%20soft%20warm%20green%20and%20cream%20gradient%20background%2C%20clean%20flat%20design%2C%20trust%20and%20safety%20theme%2C%20calm%20reassuring%20colors%2C%20minimalist%20professional%20illustration%2C%20ample%20negative%20space&width=800&height=600&seq=safety-img&orientation=landscape&nocache=true"
              alt="CSSBuy Safety Center"
              className="w-full h-64 md:h-80 object-cover"
            />
          </div>
          <div className="order-1 md:order-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
                <i className="ri-shield-check-line text-emerald-700 text-xl" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
                {t("home.safety.title")}
              </h2>
            </div>
            <p className="text-gray-600 leading-relaxed mb-6">
              {t("home.safety.content")}
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-700 text-white font-medium rounded-lg hover:bg-emerald-800 transition-colors"
            >
              {t("home.safety.cta")}
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}